/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Notifications from 'vue-notification';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueMask from 'v-mask';
// import Inputmask from "inputmask"
import store from './store/crbg';
import VueRouter from 'vue-router';
import 'quill/dist/quill.core.css'
import VueNumberic from 'vue-numeric';
import './livewireListeners';
import globalDirectives from "./directives";

require('./bootstrap');
window.Vue = Vue;

Vue.use(Notifications);
Vue.use(DatePicker);
Vue.use(VueMask);
Vue.use(VueRouter);
Vue.use(VueNumberic)
Vue.use(globalDirectives);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const componentHealthPlans = Vue.component('health-plans', require('./components/crbg/health-plans/HealthPlans').default);
Vue.component('modal-email-phone', require('./components/crbg/modals/ModalEmailPhone').default);
Vue.component('modal-demographic', require('./components/crbg/modals/ModalDemographic').default);
Vue.component('sb-demographic-information', require('./components/crbg/SBDemographicInformation').default);
Vue.component('payments-history', require('./components/crbg/health-plans/PaymentsHistory').default);
Vue.component('plan-medical', require('./components/crbg/health-plans/PlanMedical').default);
Vue.component('plan-rx', require('./components/crbg/health-plans/PlanRx').default);
Vue.component('plan-other', require('./components/crbg/health-plans/PlanOther').default);
Vue.component('plan-other-gap', require('./components/crbg/health-plans/PlanOtherGAP').default);
Vue.component('wellness-chart', require('./components/crbg/WellnessChart').default);
Vue.component('my-benefits', require('./components/crbg/MyBenefit').default);
Vue.component('sb-notifications', require('./components/crbg/SBNotifications').default);
Vue.component('sb-resources', require('./components/crbg/SBResources').default);
Vue.component('sb-supplements', require('./components/crbg/SBSupplements').default);
Vue.component('sb-supplements-add-edit', require('./components/crbg/SBSupplementsAddEdit').default);
Vue.component('sb-allergies', require('./components/crbg/SBAllergies').default);
Vue.component('sb-allergies-add-edit', require('./components/crbg/SBAllergiesAddEdit').default);
Vue.component('sb-immunizations', require('./components/crbg/SBImmunizations').default);
Vue.component('sb-immunizations-add-edit', require('./components/crbg/SBImmunizationsAddEdit').default);
Vue.component('sb-conditions', require('./components/crbg/SBConditions').default)
Vue.component('sb-conditions-add-edit', require('./components/crbg/SBConditionsAddEdit').default)
Vue.component('sb-prescriptions', require('./components/crbg/SBPrescriptions').default);
Vue.component('sb-prescriptions-add-edit', require('./components/crbg/SBPrescriptionsAddEdit').default)
Vue.component('sb-profile', require('./components/crbg/SBProfile').default)
Vue.component('sb-basic-information', require('./components/crbg/SBBasicInformation').default)
Vue.component('sb-send-phr', require('./components/crbg/SBSendPHR').default)
Vue.component('sb-emergency-contacts', require('./components/crbg/SBEmergencyContacts').default)
Vue.component('sb-content', require('./components/crbg/SBContent').default)
Vue.component('sb-notes', require('./components/crbg/SBNotes').default)
Vue.component('sb-help', require('./components/crbg/SBHelp').default)
Vue.component('sb-verify', require('./components/crbg/SBVerify').default)
Vue.component('sb-searchable-health-library', require('./components/crbg/searchable/SBSearchableHealthLibrary').default)
Vue.component('sb-searchable-health-library-post', require('./components/crbg/searchable/SBSearchableHealthLibraryPost').default)
Vue.component('sb-searchable-health-library-video', require('./components/crbg/searchable/SBSearchableHealthLibraryVideo').default)
Vue.component('sb-searchable-health-library-graphic', require('./components/crbg/searchable/SBSearchableHealthLibraryGraphic').default)
Vue.component('sb-system-announcements', require('./components/crbg/SBSystemAnnouncements').default)
Vue.component('sb-dashboard-links', require('./components/crbg/SBDashboardLinks').default)
Vue.component('multiselect', Multiselect);
Vue.component('sb-forms', require('./components/crbg/sbForms').default);
Vue.component('plan-card-medical', require('./components/crbg/health-plans/PlanCardMedical').default);
Vue.component('plan-card-rx', require('./components/crbg/health-plans/PlanCardRx').default);
Vue.component('plan-card-other', require('./components/crbg/health-plans/PlanCardOther').default);
Vue.component('plan-card-other-gtli', require('./components/crbg/health-plans/PlanCardOtherGTLI').default);
Vue.component('plan-card-other-ublic', require('./components/crbg/health-plans/PlanCardOtherUblic').default);
Vue.component('plan-card-other-ublic-retiree', require('./components/crbg/health-plans/PlanCardOtherUblicRetiree').default);
Vue.component('plan-card-other-irp', require('./components/crbg/health-plans/PlanCardOtherIRP').default);
Vue.component('plan-card-other-gap', require('./components/crbg/health-plans/PlanCardOtherGAP').default);
Vue.component('sb-registration', require('./components/crbg/SBRegistration').default);
Vue.component('auto-logout', require('./components/AutoLogout').default);
Vue.component('left-sidebar-component', require('./components/crbg/LeftSidebarComponent').default);
Vue.component('header-menu-component', require('./components/crbg/HeaderMenuComponent').default);
Vue.component('header-navigate-component', require('./components/crbg/HeaderNavigateComponent').default);
Vue.component('footer-component', require('./components/crbg/FooterComponent.vue').default);
Vue.component('hsid-login', require('./components/crbg/login/HsidLogin').default);

const routes = [
    {
        path: '/employee-benefits',
        component: componentHealthPlans,
        name: 'healthplans',
        children: [
            {
                path: ':planSlug',
                name: 'healthplans.detail',
                component: componentHealthPlans,
            },
            {
                path: ':planSlug/payments',
                name: 'healthplans.payments',
                component: componentHealthPlans,
            },
        ]
    },
]

const router = new VueRouter({routes, mode: 'history'})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.addEventListener('load', function() {
    const app = new Vue({
        el: '#app',
        router,
        store,
        components: {
            Multiselect,
        },
        created() {
            if (window.appData) {
                this.$store.dispatch('user/setUser', window.appData.user);
                window.appData = null;
            } else {
                console.error('No app data found in window.');
            }
        },
        mounted() {
            Livewire.start();
        },
        methods: {
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            },
            clickedINeedMedicalCare() {
                window.open('/medical-care-pdf', '_blank');
            },
        }
    });

    // app.use(router)

    $('.modal-card-viewed').click(function() {
        const id = $(this).data('id');
        const campaignId = $(this).data('campaign-id');
        $.get(`/api/report-viewed-cards/${id}/${campaignId}`);
    });

    document.addEventListener("click", listenForOptInButtonClick);

    function listenForOptInButtonClick(event) {
        var element = event.target;
        if(element.classList.contains('opt-in-button')) {
            element.disabled = true;
            const dataLocation = element.getAttribute('data-location');
            let id;
            if(dataLocation === "card") {
                $('.modal-card').modal('toggle');
                $('#sbhealth-thank-you-card').modal('toggle');
                id = element.getAttribute('data-id');
                $.get(`/api/report-wellness-opt-in/${id}`)
            }  else {
                id = null;
                $('#opt-in-button').prop("disabled", true);
                $.get(`/api/report-wellness-opt-in/${id}`).then(function() {
                    app.$refs.sbcontent.reloadPage();
                });
            }
        }
    }

    $('#dob-register').on('keyup', function () {
        var val = $(this).val().replace(/\D/g, '');
        if (val.length > 2) {
            val = val.slice(0, 2) + '/' + val.slice(2);
        }
        if (val.length > 5) {
            val = val.slice(0, 5) + '/' + val.slice(5);
        }
        $(this).val(val);
    });
})
window.bus = new Vue();
window.moment = require('moment');
Vue.use(require('vue-resource'));
Vue.http.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
Vue.http.interceptors.push(function(request,next){
    next(function(response){
        if(response.status == 403 && response.data.exception_name == "restriction"){
            this.$notify({
                type: 'error',
                title: 'Error',
                text: 'Emulated users may not make changes to member data.'
            });
        }

    });
})

